import { BrowserModule } from '@angular/platform-browser'
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core'
import { Router } from '@angular/router'
import * as Sentry from '@sentry/angular'
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule } from '@angular/forms'
import { take } from 'rxjs/operators'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { NzNotificationModule } from 'ng-zorro-antd/notification'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core'
import { NgxWebstorageModule } from 'ngx-webstorage'
import { AuthorizationInterceptor } from '@adex/shared/interceptors/authorization.interceptor'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { IconsProviderModule } from './icons-provider.module'
import { ModelLoaderService } from '@adex/shared/services/model-loader.service'
import { ImageLoaderService } from '@adex/shared/components/image/image-loader.service'
import { environment } from '../environments'
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n'
import { CustomHttpClient } from '@adex/shared/network/custom-http-client'
import { GlobalStoreModule } from '@adex/store/global-store.module'
import { IntercomModule } from 'ng-intercom'
import { NzButtonModule } from 'ng-zorro-antd/button'


function translateLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${ environment.version }`)
}

const providers = []
if (environment.production) {
  providers.push(
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ showDialog: false })
    },
    {
      provide: Sentry.TraceService,
      deps: [ Router ]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [ Sentry.TraceService ], multi: true
    }
  )
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzNotificationModule,
    NgxWebstorageModule.forRoot({ prefix: 'adex' }),
    TranslateModule.forRoot(),
    GlobalStoreModule,
    IntercomModule.forRoot({
      appId: environment.intercomAppId,
      updateOnRouterChange: true
    }),
    NzButtonModule
  ],
  providers: [
    ...providers,
    { provide: NZ_I18N, useValue: en_US },
    { provide: TranslateLoader, useFactory: (translateLoaderFactory), deps: [ HttpClient ] },
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
    { provide: 'googleTagManagerId', useValue: environment.gtmId },
    CustomHttpClient
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {

  constructor(
    translate: TranslateService,
    modelLoader: ModelLoaderService,
    iconLoader: ImageLoaderService
  ) {
    translate.setDefaultLang('en')
    translate.get('INIT').pipe(take(1)).subscribe()
    modelLoader.startPreload()
    iconLoader.startPreload()
  }

}
